import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

import { getCurrenLocaleObj } from "../functions";

$(function() {
    const currenLocaleObj = getCurrenLocaleObj();

    $(".checkmemberemailfield")
        .closest("form")
        .on("submit", function(event, passThough) {
            if (passThough) {
                return true;
            }
            event.preventDefault();
            var $form = $(this);
            // On /dashboard/profile it is using this for both the email and username so it doesn't work correctly.
            // On the register modal it only uses it for the email
            // And on /account/profile it only uses it for the username
            // It can only be used on one field per form
            var $emailInput = $form.find(".checkmemberemailfield").first();
            var check = $emailInput.attr("data-url");
            if ($emailInput.val().length) {
                $.ajax({
                    type: "GET",
                    url: check, // this doesn't need currenLocaleObj.urlPrefix. It already has it.
                    data: {
                        Email: $emailInput.val()
                    },
                    dataType: "json",
                    success: function(data) {
                        if (data.MemberExists === true) {
                            if ($('#registerModal').is(':visible') && $('#MemberLoginForm_LoginForm_Email').length) {
                                // Don't need to show the login modal because if there is an error logging in we are redirected to the login page i.e. https//www.hpacademy.com/account/login/?signin=false&BackURL=/home/
                                // $('.js-displayLoginPrompt').trigger('click'); // This hides the register modal and shows the login modal
                                $('#MemberLoginForm_LoginForm_Email').val($('#RegisterEmail').val());
                                $('#MemberLoginForm_LoginForm_Password').val($('#RegisterPassword').val());
                                $('#MemberLoginForm_LoginForm_action_dologin').trigger('click');
                            } else {
                                $emailInput.addClass("parsley-error");
                                $emailInput.addClass("error");
                                $emailInput.siblings(".form-error").show();
                                $emailInput.focus();
                            }
                            return false;
                        } else {
                            $emailInput.removeClass("parsley-error");
                            $emailInput.removeClass("error");
                            $emailInput.siblings(".form-error").hide();
                            $form.trigger("submit", [true]); // true here sets passThough to true
                            return true;
                        }
                    }
                });
            }
        });

    // Only used when the /account/profile page is reloaded and the nickname already exists
    // $('.nickname-exists-error').on('keyup', function() {
    //     var $this = $(this);
    //     $this.removeClass('nickname-exists-error').removeClass('parsley-error');
    //     $this.siblings('.parsley-errors-list').remove();
    // });
    const $profileCompleteFormNickname = $('#ProfileCompleteForm_ProfileCompleteForm_Nickname');
    if ($profileCompleteFormNickname.length) {
        window.Parsley.addValidator('hpaNicknameCheck', {
            validateString: function(_ignoreValue, country, instance) {
                const username = $profileCompleteFormNickname.val(),
                    xhr = $.ajax({
                        url: currenLocaleObj.urlPrefix + '/account/ProfileCompleteForm/field/Nickname/check',
                        method: 'GET',
                        data: { Nickname: username },
                        dataType: 'json',
                        cache: false,
                    });

                return xhr.then(function(json) {
                    if (json.NicknameExists) {
                        // We could return `false`, but for an even better result
                        // we can fail the promise with a custom error message:
                        return $.Deferred().reject(hpaTranslatedtext.checkmemberemailfield.validation.usernameTaken.replace('%s', '' + username + '')); // The username "%s" is already taken
                        // Note: in jQuery 3.0+, you can `throw('my custom error')` for the same result
                    }
                })
            },
            // The following error message will still show if the xhr itself fails
            // (404 because zip does not exist, network error, etc.)
            // messages: { en: '' }
        });

        $profileCompleteFormNickname.on('blur', function() {
            const $this = $(this);

            $this.parsley().validate();
        });
    }
});



// WEBPACK FOOTER //
// ./js/modules/checkmemberemailfield.js